import React from 'react';
import { NavLink } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const BlogCard = ({ post, featured = false }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <article 
      className={`group bg-card rounded-xl overflow-hidden border border-border hover:shadow-lg transition-all duration-300 ${
        featured ? 'md:col-span-2 lg:col-span-2' : ''
      }`}
    >
      <NavLink to={`/blog-posts/${post?.id}`} className="block">
        <div className={`relative overflow-hidden ${featured ? 'h-64 md:h-80 lg:h-96' : 'h-48 md:h-56 lg:h-64'}`}>
          <Image
            src={post?.image}
            alt={post?.imageAlt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {featured && (
            <div className="absolute top-4 left-4 bg-accent text-accent-foreground px-3 py-1 rounded-md text-sm font-medium">
              Featured
            </div>
          )}
          <div className="absolute bottom-4 left-4 bg-card/90 backdrop-blur-sm px-3 py-1 rounded-md">
            <span className="text-xs font-medium text-foreground">{post?.category}</span>
          </div>
        </div>

        <div className="p-4 md:p-5 lg:p-6">
          <div className="flex items-center gap-3 mb-3 text-xs md:text-sm text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <Icon name="Calendar" size={14} />
              <span>{formatDate(post?.publishedDate)}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Clock" size={14} />
              <span>{post?.readTime} min read</span>
            </div>
          </div>

          <h3 className={`font-semibold text-foreground mb-2 group-hover:text-accent transition-colors line-clamp-2 ${
            featured ? 'text-xl md:text-2xl lg:text-3xl' : 'text-base md:text-lg lg:text-xl'
          }`}>
            {post?.title}
          </h3>

          <p className={`text-muted-foreground mb-4 ${
            featured ? 'line-clamp-3 text-sm md:text-base' : 'line-clamp-2 text-sm'
          }`}>
            {post?.excerpt}
          </p>

          <div className="flex items-center justify-between pt-4 border-t border-border">
            <div className="flex items-center gap-2">
              <Image
                src={post?.author?.avatarUrl}
                alt={`${post?.author?.fullName || 'Author'} avatar`}
                className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover"
              />
              <span className="text-xs md:text-sm font-medium text-foreground">{post?.author?.fullName}</span>
            </div>

            <div className="flex items-center gap-3">
              {post?.commentCount > 0 && (
                <div className="flex items-center gap-1 text-muted-foreground">
                  <Icon name="MessageCircle" size={16} />
                  <span className="text-xs md:text-sm">{post?.commentCount}</span>
                </div>
              )}
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  console.log('Share post:', post?.id);
                }}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Share post"
              >
                <Icon name="Share2" size={16} color="var(--color-muted-foreground)" />
              </button>
            </div>
          </div>
        </div>
      </NavLink>
    </article>
  );
};

export default BlogCard;